import { Button, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { biddingService } from '../../../../services/client';
import * as React from 'react';
import { useState } from 'react';
import BidderLogo from '../../../../bidder/assets/images/bidder.svg';

export default function StageAuthorizationModal({ stage, onApprove, onClose }) {
  const [errors, setErrors] = useState({});
  const [password, setPassword] = useState('');
  const handleApproveAuthorization = () => {
    console.log('Approve');

    biddingService
      .authorizeStage(stage.authorization_stage.bidding_id, stage.authorization_stage.stage, {
        password
      })
      .then((result) => {
        onApprove();
        console.log(result);
      })
      .catch((error) => {
        if (error.response.status === 422) {
          let response = error.response.data;
          setErrors(response.errors);
        }
      });
  };

  const handleCloseAuthorization = () => {
    console.log('Close');
    onClose();
  };

  return (
    <>
      <div className={'authorization-overlay'}>
        <div className={'authorization-modal authorization-modal-with-background'}>
          <div className={'authorization-modal-content'}>
            <div className={'authorization-modal-logo'}>
              <img src={BidderLogo} alt={'Bidder Logo'} />
            </div>
            <div className={'authorization-modal-header'}>Action Needed</div>
            <div className={'authorization-modal-body'}>
              <div className={'stack'}>
                <div>
                  The Administrator seeks authorization to conclude the ongoing stage of the
                  following bidding:
                </div>
                <div>
                  <strong>Macro Bidding “ {stage.authorization_stage.macro_title} “</strong>
                  <br />
                  <strong>SubBidding “ {stage.authorization_stage.micro_title} ”</strong>
                </div>
                <div>
                  The vendors listed below have been selected to progress to the subsequent stage:
                </div>
                <dd>
                  {stage.authorization_stage.vendors.map((vendor) => (
                    <li key={vendor.id}>{vendor.name}</li>
                  ))}
                </dd>
                <div>
                  To proceed with this authorization, kindly input your password in the designated
                  field. This step ensures the security and integrity of the process.
                </div>
              </div>
              <div className={'authorization-modal-body--password-holder'}>
                <FormControl fullWidth size={'small'} error={!!errors.password} variant="outlined">
                  <InputLabel htmlFor="login-password">Password</InputLabel>
                  <OutlinedInput
                    id="login-password"
                    type={'password'}
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    label="Password"
                  />
                  {typeof errors.password !== 'undefined' && (
                    <FormHelperText>{errors.password}</FormHelperText>
                  )}
                </FormControl>
              </div>
            </div>
            <div className={'authorization-modal-footer'}>
              <Button variant="fm-outlined" onClick={handleApproveAuthorization}>
                Accept
              </Button>
              <Button variant="fm-outlined" onClick={handleCloseAuthorization}>
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
